import {Grid} from "@mui/material";
import {CopyUtils} from "../../util/CopyUtils";
import {SubmissionTranslKey} from "../submission/SubmissionTranslKey";
import {useTranslation} from "react-i18next";
import {SubmissionFilterDto} from "../../client/submission/SubmissionApiClient";
import DateField from "../../common/form/DateField";
import {DateTimeFormatter} from "../../common/DateTimeFormatter";

export interface RecentSubmissionFilterFormProps {
    filter: SubmissionFilterDto;
    onChange: (filter: SubmissionFilterDto) => void;
}

export function RecentSubmissionFilterForm(props: Readonly<RecentSubmissionFilterFormProps>) {
    const {filter, onChange} = props;

    const {t} = useTranslation();

    function onSubmittedAtFromChange(submittedAtFrom: Date | undefined) {
        const updatedFilter = CopyUtils.deepCopy(filter);
        updatedFilter.submittedAtFrom = submittedAtFrom;
        onChange(updatedFilter);
    }

    function onSubmittedAtToChange(submittedAtTo: Date | undefined) {
        const updatedFilter = CopyUtils.deepCopy(filter);
        updatedFilter.submittedAtTo = DateTimeFormatter.convertToEndOfDay(submittedAtTo);
        onChange(updatedFilter);
    }

    return (
        <Grid container mt={0} spacing={2}>
            <Grid item xs={12} sm={6} md={3}>
                <DateField
                    label={t(SubmissionTranslKey.SUBMISSIONS_SUBMITTED_AT_FROM)}
                    value={filter.submittedAtFrom}
                    onChange={onSubmittedAtFromChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
                <DateField
                    label={t(SubmissionTranslKey.SUBMISSIONS_SUBMITTED_AT_TO)}
                    value={filter.submittedAtTo}
                    onChange={onSubmittedAtToChange}
                />
            </Grid>
        </Grid>
    );
}
